import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export interface ConfigInfoData {
  webname: string;
  image_server: string;
  image_site: string;
  ad_down: string;
  ios_down: string;
  share_url: string;
  live_url: string;
  service_email: string;
  service_wechat: string;
  service_qq: string;
  contact_info: string;
  business_email: string;
}

export interface SettingsState {
  theme: 'light' | 'dark';
  language: string;
  configInfo?: ConfigInfoData;
}

const initialState: SettingsState = {
  theme: 'light',
  language: 'zh',
  configInfo: undefined,
};


const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<'light' | 'dark'>) {
      state.theme = action.payload;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    setConfigInfo(state, action: PayloadAction<ConfigInfoData>) {
      state.configInfo = action.payload;
    },
  },
});

export const { setTheme, setLanguage, setConfigInfo } = settingsSlice.actions;
export default settingsSlice.reducer;
